/* istanbul ignore file */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Most of the time all you need is to “scroll to the top”
 * because you have a long content page, that when
 * navigated to, stays scrolled down.
 * This is straightforward to handle with a <ScrollToTop>
 * component that will scroll the window up on every navigation
 */
interface IScrollToTop {
  dependencies?: unknown[];
}

export function ScrollToTop({ dependencies = [] }: IScrollToTop) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, ...dependencies]);

  return null;
}
